import {ResponseBase} from './ResponseBase';
import {Utils} from '../Utils/index';
import {ErrorMessage, IErrorResponse} from './Types';

/**
 * @class ErrorResponse - error response contains info about error like: code, message.
 */
export class ErrorResponse extends ResponseBase implements IErrorResponse {
    /**
     * @property code - specific error code (list of generic codes see below)
     * @see @ApiErrorCodes for valid error codes
     */
    code: number;

    /**
     * @property errorId - unique error identifier.
     */
    errorId: string;

    /**
     * @property message - detailed error message
     */
    message: string;

    /**
     * @property messages - list of messages to display to player
     */
    messages: Array<ErrorMessage>;

    /**
     * @property intervals - list of reality check/session timer intervals
     */
    intervals: Array<number>;

    protected internalValidate(errors: Array<string>): void {
        if (Utils.isNullOrUndefined(this.code)) {
            errors.push('Property "code" is missing or has null/undefined value!');
        } else if (typeof this.code !== 'number') {
            errors.push('Property "code" has wrong type, required type is "number"!');
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/ApiClient/ErrorResponse.ts
 **/